export const ACTIONS_KPI = {
  INVALIDATE: 'KPIS_INVALIDATE',
  RECEIVE: 'KPIS_RECEIVE',
  DELETE: 'KPI_DELETE',
  UPDATE: 'KPI_UPDATE',
};

const kpiConstants = {};

export default kpiConstants;
